import styled from 'styled-components';

import { Modal, Row, Divider, colors } from '@dexma/ui-components';

export const StyledDashboarShareModal = styled(Modal)``;

export const StyledUpperRowLabel = styled.div`
    margin-bottom: 4px;
`;

export const StyledUpperRow = styled.div`
    margin-bottom: 16px;
    width: 100%;
    display: flex;
    justify-content: space-around;

    .ant-select-selection-search {
        input {
            min-height: auto;
        }
    }
`;

export const StyledMiddleBlock = styled.div`
    margin-bottom: 16px;
    align-items: flex-start;
`;

export const StyledLowerRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledPublicDashboard = styled.div`
    display: flex;
    width: '100%';
    span {
        display: flex;
    }
`;

export const StyledUserGroupRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0px;
`;

export const StyledDividerWithMargin = styled(Divider)`
    margin-bottom: 8px;
`;

export const StyledDividerWithTwoMargins = styled(Divider)`
    margin-bottom: 8px;
    margin-top: 8px;
`;

export const StyledCenteredButton = styled.div`
    width: 20%;
`;

export const StyledNotSharedMessage = styled(Row)`
    color: ${colors.gray300};
    justify-content: center;
    min-height: 80px;
`;
export const StyledDisclaimerMessage = styled.div`
    background-color: ${colors.gray100};
    border-radius: 4px;
    padding: 12px 0px;
    margin: 12px 0px;
`;
